import { CommonSetting } from '../../../../commons/kymw00/common-setting';
import { KYMW1600Model } from '../kymw1600.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';

/**
 * 画像情報取得要求サービス
 *
 * @export ReplaceImageFileUploadService
 * @class ReplaceImageFileUploadService
 * @extends {PlessJsonUploadServiceSub}
 */
@Injectable()
export class ReplaceImageFileUploadService extends PlessJsonUploadServiceSub<any> {
  public static readonly KEY_IMAGE_PREVIEW_EXT = 'ImagePreviewExt';	                // 画像プレビュー画像拡張子(png)
  public static readonly KEY_IMAGE_FILE_EXT: string = <string>'ImageFileExt';		    // 画像ファイルの拡張子(eps)
  public static readonly KEY_IMAGE_CWS_EXT: string = <string>'ImageCWSExt';		      // CWS画像ファイル拡張子(jpg)
  public static readonly KEY_IMAGE_FILE_SMALL: string = <string>'ImageFileSmall';	  // 画像ファイル名(小)
  public static readonly KEY_IMAGE_FILE_MIDDLE: string = <string>'ImageFileMiddle';	// 画像ファイル名(中)
  public static readonly KEY_IMAGE_FILE_LARGE: string = <string>'ImageFileLarge';	  // 画像ファイル名(大)

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof ReplaceImageFileUploadService
   */
  private model: KYMW1600Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof ReplaceImageFileUploadService
   */
  private vo: {
    fileRef: File,
  };

  /**
   * 成功時に行う処理
   *
   * @private
   * @type {Function}
   * @memberof ReplaceImageFileService
   */
  private successFunction: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof ReplaceImageFileUploadService
   */
  execute(model: KYMW1600Model, vo: any, successFunction: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunction = successFunction;
    this.sendFile('KYMW16ReplaceImageFileUpload',  new PlessRequest(), vo.fileRef);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ReplaceImageFileUploadService
   */
  success(data: any): void {
    const pngExt: string	= '.' + CommonSetting.getVal(ReplaceImageFileUploadService.KEY_IMAGE_PREVIEW_EXT);
    const jpgExt: string	= '.' + CommonSetting.getVal(ReplaceImageFileUploadService.KEY_IMAGE_CWS_EXT);
    const sPrefix: string	= CommonSetting.getVal(ReplaceImageFileUploadService.KEY_IMAGE_FILE_SMALL);
    const mPrefix: string	= CommonSetting.getVal(ReplaceImageFileUploadService.KEY_IMAGE_FILE_MIDDLE);
    const lPrefix: string	= CommonSetting.getVal(ReplaceImageFileUploadService.KEY_IMAGE_FILE_LARGE);

    // 一時ファイル名のチェック
    // PNGファイルの場合
    if (String(data.TempFileName).indexOf(pngExt) > 0) {
      this.model.tempPNGFileName = String(data.TempFileName);
    // JPG(S)ファイルの場合
    } else if (String(data.TempFileName).indexOf(sPrefix + jpgExt) > 0)	{
      this.model.tempJPGSFileName = String(data.TempFileName);
    // JPG(M)ファイルの場合
    } else if (String(data.TempFileName).indexOf(mPrefix + jpgExt) > 0) {
      this.model.tempJPGMFileName = String(data.TempFileName);
    // JPG(L)ファイルの場合
    } else if (String(data.TempFileName).indexOf(lPrefix + jpgExt) > 0) {
      this.model.tempJPGLFileName = String(data.TempFileName);
    // EPSファイルの場合
    } else {
      this.model.tempEPSFileName = String(data.TempFileName);
    }

    // 成功関数実行
    this.successFunction();
  }
}
